import router from "../router/index";
import axios from "axios";
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";

const fetch = axios.create({
	timeout: 60 * 1000, // 设置超时时间
});

// 请求拦截器
fetch.interceptors.request.use(
	(config) => {
		config.headers['token'] = '';
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// 响应拦截器
fetch.interceptors.response.use(
	(res) => {
		// 其它状态码可自行进行补充
		if (res.status === 200) {
			return res.data;
		} else {
			return Promise.reject(res.data);
		}

	},
	(error) => {
		console.log(error);
		return Promise.reject(error);
	}
);

export default fetch;